/**
 * Bloggle Article Enhancements
 *
 * 1. TOC: Converts fragment links to JS scroll (SEO + accessibility)
 * 2. Sidebar: Mobile scroll behavior for related product sidebar
 */
(function() {
  'use strict';

  // Prevent duplicate initialization
  if (window._bloggleTocInitialized) return;
  window._bloggleTocInitialized = true;

  // Constants
  var MOBILE_BREAKPOINT = 768;
  var SCROLL_THRESHOLD = 120;

  /**
   * Mobile sidebar scroll behavior
   * Shows/hides related product sidebar based on scroll position
   * Uses requestAnimationFrame for performance throttling
   */
  function initSidebarScroll() {
    var sidebar = document.querySelector('#bloggle_sideBar');
    var product = document.querySelector('#bggle--product-related');

    if (!sidebar || !product) return;

    var ticking = false;

    function handleScroll() {
      var isSmallScreen = window.innerWidth < MOBILE_BREAKPOINT;
      if (isSmallScreen) {
        if (window.scrollY > SCROLL_THRESHOLD) {
          sidebar.style.transform = 'translateY(0px)';
        } else {
          sidebar.style.transform = 'translateY(' + SCROLL_THRESHOLD + 'px)';
        }
      }
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /**
   * TOC Enhancement
   * Converts fragment hrefs to JS scroll handlers for SEO
   * Adds accessibility: role="button", tabindex, keyboard support
   */
  function initTocLinks() {
    var bloggleContent = document.getElementById('bloggle_rte');
    if (!bloggleContent) return;

    var tocLinks = bloggleContent.querySelectorAll('a[href^="#"]');

    tocLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      // Only process numeric fragment IDs (Bloggle timestamps like #1725968857968)
      if (href && /^#\d+$/.test(href)) {
        var targetId = href.substring(1);

        // Remove href to prevent Google indexing fragment URLs
        link.setAttribute('data-scroll-target', targetId);
        link.removeAttribute('href');

        // Accessibility: make it behave like a button
        link.setAttribute('role', 'button');
        link.setAttribute('tabindex', '0');
        link.style.cursor = 'pointer';

        // Scroll handler (closure to capture targetId)
        var scrollToTarget = function() {
          var target = document.getElementById(targetId);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        };

        // Click support
        link.addEventListener('click', scrollToTarget);

        // Keyboard support (Enter/Space) for accessibility
        link.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            scrollToTarget();
          }
        });
      }
    });
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    initSidebarScroll();
    initTocLinks();
  });
})();
